import { computed, ComputedRef } from 'vue';
import { Subscription, useUserContext } from '@ilteducation/ilt-auth';

const useSubscriptions = (): ComputedRef<Subscription[]> => {
  const userContext = useUserContext();

  return computed(() =>
    userContext.subscriptions.filter((activeSubscription: Subscription) =>
      activeSubscription.type.startsWith('immigrant'),
    ),
  );
};

export default useSubscriptions;
